import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

/** draft: hidden from members; coming_soon: listed without content; published: can be unlocked. */
export type Status = 'draft' | 'coming_soon' | 'published';

export type V = {
  '@id': string;
  '@type': 'Program';
  id: string;
  number: number;
  title: string;
  totalWeeks: number;
};

export type V_AsAdmin = V & {
  status: Status;
};

/** Every program, drafts included (admin only). */
export function useReadCollectionAsAdmin(options?: ReadConfig) {
  return useApiRead<HydraCollection<V_AsAdmin>>(`/programs`, options);
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/programs/${id}`, options);
}
